import type { Dict, Mixpanel } from "mixpanel-browser";

export function attemptTrack(
  mixpanelInstance: Mixpanel,
  eventName: string,
  properties: Dict | undefined,
  retries: number = 0,
  maxRetries: number = 5,
  retryDelay: number = 1000
) {
  if (mixpanelInstance) {
    return mixpanelInstance.track(eventName, properties);
  }

  if (retries < maxRetries) {
    return setTimeout(() => {
      attemptTrack(mixpanelInstance, eventName, properties, retries + 1);
    }, retryDelay);
  }

  throw new Error(`Mixpanel track failed after ${maxRetries} retries for event: ${eventName}`);
}